import React from 'react';
import { Link } from 'react-router-dom';
import Searchbox from './Searchbox';
 

const Home = (props) => {
  
    
 
    return (
        <div className='row minHeightRow'>
         <Searchbox />
         
         {/* Documentation Link */}
         {/* <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <Link 
                to="/documentation" 
                style={{
                    display: 'inline-block',
                    background: 'linear-gradient(135deg, #48dc4e 0%, #3fc845 100%)',
                    color: 'white',
                    padding: '12px 24px',
                    borderRadius: '25px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    boxShadow: '0 4px 15px rgba(72, 220, 78, 0.3)',
                    transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(72, 220, 78, 0.4)';
                }}
                onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(72, 220, 78, 0.3)';
                }}
            >
                📚 View Widget Documentation
            </Link>
         </div> */}
      
      </div>
    );
}

export default Home;